import { SENTRY_ENABLE } from '@shared/env/index';
import type { UserState } from '@shared/stores/User/types';
import { browserTracingIntegration, init, setUser, withScope } from '@sentry/react';
import type { Scope } from '@sentry/react';

import { SENTRY_DSN } from './config';

/**
 * 初始化 sentry
 */
export const initSentry = () => {
	console.log('SENTRY_ENABLE', SENTRY_ENABLE);
	if (!SENTRY_ENABLE) return;

	init({
		beforeSend(event, hint) {
			if (hint.originalException === 'Timeout') return null;

			if (event.exception) {
				// 获取错误消息
				const errorMessage = event.exception.values?.[0]?.value || '';
				// 如果错误包含特定的网络错误关键字，过滤掉该事件
				if (errorMessage.includes('NETWORK_ERROR')) {
					return null;
				}
			}
			return event;
		},
		dsn: SENTRY_DSN,
		// 性能监控
		integrations: [browserTracingIntegration()],
		autoSessionTracking: false,
		tracesSampleRate: 0.05,
		sampleRate: 0.05,
		environment: window.location.hostname,
	});
};

/**
 * 设置当前 sentry 的用户信息
 * @param info
 */
export const handleSentryUserChange = (info: Partial<UserState['userState']> = {}) => {
	if (info.userId) {
		setUser({
			id: info.userId,
			username: info.userName,
			email: info.email,
		});
		// 未登录状态
	} else {
		setUser({
			id: 'anonymous',
			username: 'anonymous',
		});
	}
};

/**
 * 设置当前异常的上下文
 * @param fn
 * @returns
 */
export const sentryScopeSet = (fn: (scope: Scope) => void) => {
	if (!SENTRY_ENABLE) return;

	withScope((scope) => {
		fn?.(scope);
	});
};
